let headerFont = '-apple-system,".SFNSDisplay-Bold","Helvetica Neue","Roboto","Segoe UI",sans-serif';
let bodyFont = "'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Verdana, Tahoma, sans-serif";
let colors = {
  gray: '#999',
  black: '#333',
  lightBg: '#eee',
  border: '#ccc',
  white: '#fff',
};

export default {
  root: {
    height: '100%',
    fontSize: '14px',
    fontFamily: bodyFont,
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
  },
  absoluteMaxCentered: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'center',
    margin: '0',
    backgroundColor: colors.lightBg,
    fontFamily: headerFont,
  },
  mainRow: {
    display: 'flex',
    flex: '1 1 100px',
    justifyContent: 'center',
  },
  commandsRow: {
    flex: '0 0 auto',
  },
  statsRow: {
    flex: '0 0 auto',
    backgroundColor: colors.gray,
    color: colors.lightBg,
    padding: '5px',
  },
  player: {
    position: 'relative',
    top: 0, left: 0, right: 0, bottom: 0,
    height: '100%',
    width: '100%',
  },
  maxRow: {
    flex: '1 1 auto',
  },
  leftCol: {
    flex: '1 1 200px',
    maxWidth: '300px',
    overflow: 'scroll',
  },
  centerCol: {
    flex: '2 2 500px',
    border: '1px solid ' + colors.border,
  },
  rightCol: {
    flex: '1 1 200px',
    maxWidth: '300px',
    overflow: 'scroll',
  },
  footer: {
    flex: '0 0 auto',
    padding: '5px',
    backgroundColor: colors.lightBg,
    margin: '0',
  },
  explorerSelected: {
    backgroundColor: colors.gray,
  },
  explorerNotSelected: {
    backgroundColor: colors.white,
    cursor: 'pointer',
  },
};



// WEBPACK FOOTER //
// ./src/components/styles.js